import { render, staticRenderFns } from "./BlacklistReasonForm.vue?vue&type=template&id=6082719e&"
import script from "./BlacklistReasonForm.vue?vue&type=script&lang=js&"
export * from "./BlacklistReasonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports